<template>
  <div class="flex gap-3 pb-4 border-b last:border-0">
    <!-- Product image -->
    <NuxtLink :to="$localePath({ name: 'product-slug', params: { slug: product.slug } })" class="shrink-0" @click="emit('close')">
      <div class="relative w-24 h-24 overflow-hidden rounded-lg bg-gray-100">
        <img
          v-if="product.images.length > 0"
          :src="product.images[0].url"
          :alt="product.name"
          class="w-full h-full object-cover"
          loading="lazy"
        />
        <img
          v-else
          src="/img/placeholder.jpg"
          :alt="product.name"
          class="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
    </NuxtLink>

    <!-- Product details -->
    <div class="flex-1 min-w-0">
      <NuxtLink :to="$localePath({ name: 'product-slug', params: { slug: product.slug } })" @click="emit('close')">
        <h5 class="text-sm font-medium leading-tight mb-2 line-clamp-2 hover:text-primary transition-colors">
          {{ product.name }}
        </h5>
      </NuxtLink>
      
      <div class="mb-3">
        <Price v-if="product.price" :value="product.price" :oldPrice="product.regularPrice" class="text-base font-bold text-gray-900 dark:text-gray-100" />
        <Price v-else :value="product.regularPrice" class="text-base font-bold text-gray-900 dark:text-gray-100" />
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-2">
        <UButton 
          size="sm" 
          color="neutral" 
          variant="solid" 
          icon="i-heroicons-shopping-cart"
          @click="emit('add-to-cart')"
          aria-label="Add to cart"
          label="Add to cart"
        />
        <UButton
          size="sm"
          color="error"
          variant="ghost"
          icon="i-heroicons-x-mark"
          @click="emit('remove')"
          aria-label="Remove from wishlist"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Price from '~/components/molecules/Price.vue'

defineProps<{
  product: any
}>()

const emit = defineEmits<{
  (e: 'add-to-cart'): void
  (e: 'remove'): void
  (e: 'close'): void
}>()
</script>
